import { gql } from '@generated/gql';

gql(`
  fragment ThankYouBasket on Basket {
    id
    energy {
      ...EnergyBasket
    }
    mobile {
      ...BasketMobileFragment
    }
    quotes {
      ...BundleQuote
    }
    details {
      ...BasketDetails
      accountNumber
    }
    monthlyCost {
      ...MoneyAmount
    }
    discounts {
      description
      qualified
      id
      creditFrequency
      credit {
        ... on AmountCredit {
          amount
        }
        ... on PercentageCredit {
          percentage
        }
      }
    }
    selectedQuotes {
      ...BundleQuote
    }
    basketStatus {
      ...BasketStatus
    }
    isPropertyAlreadySupplied
  }
`);

export const thankYouQuery = gql(`
  query GetThankYouData($basketId: ID!) {
    basket(id: $basketId) {
      ...ThankYouBasket
    }
    attributionDetails(basketId: $basketId) {
      ...AttributionDetails
    }
    broadbandSwitchDetails(basketId: $basketId) {
      losingProvider
      providerNotListed
    }
  }
`);
